<template>
<div class="delivery-card" v-if="delivery">
  <div class="delivery-content">
    <div class="delivery-icon" v-if="!!supportedIcon?.icon">
      <img class="icon" v-webp :src="supportedIcon?.icon">
    </div>
    <ul>
      <li class="delivery-title" v-html="delivery.shippingTimeDescription || ''" />
    </ul>
  </div>
</div>
</template>

<script setup lang="ts">
const props = defineProps<{ delivery: ProductV3.ShippingTime }>()

interface ISupportedIcon { icon: string, title: string, color: string }

const supportedIcon = computed<ISupportedIcon | undefined>(() => {
  if(props.delivery.logisticsType === 'fbk') {
    let iconUrl = 'https://image.kilimall.com/c/h5/imgs/ic_details_logistics_fbk.png'
    let color = '#f87724'
    if (isFacebook().value || isTiktok().value || isWhatsApp().value) {
      iconUrl = 'https://image.kilimall.com/c/h5/imgs/ic_fulfilled_by_kilimall.png'
      color = '#030303'
    }
    return { icon: iconUrl, title: 'Fulfilled By Kilimall', color: color }
  }

  if(props.delivery.logisticsType === 'gs'){
    let iconUrl = 'https://image.kilimall.com/c/h5/imgs/ic_details_logistics_gs.png'
    let color = '#7054a1'
    if (isFacebook().value || isTiktok().value || isWhatsApp().value) {
      iconUrl = 'https://image.kilimall.com/c/h5/imgs/ic_oversea_shipment.png'
      color = '#030303'
    }
    return { icon: iconUrl, title: 'Oversea Shipment', color: color }
  }

  if(props.delivery.logisticsType === 'ds'){
    let iconUrl = 'https://image.kilimall.com/c/h5/imgs/ic_details_logistics_drop.png'
    let color = '#45b75d'
    if (isFacebook().value || isTiktok().value || isWhatsApp().value) {
      iconUrl = 'https://image.kilimall.com/c/h5/imgs/ic_local_dispatch.png'
      color = '#030303'
    }
    return { icon: iconUrl, title: 'Local Dispatch', color: color }
  }
})
</script>

<style lang="scss" scoped>
.delivery-card{
  .icon{
    height: 50px;
    width: 50px;
    min-width: 50px;
    margin-right: 20px;
    margin-top: 10px;
  }
  .delivery-title{
    font-size: 26px;
  }
  .delivery-content{
    display: flex;
    font-size: 26px;
    align-items: center;
    margin-top: 10px;
  }
}
</style>